
const { ccclass, menu, property, executeInEditMode, inspector } = cc._decorator;

@ccclass
@menu('custom/customRichText')
@executeInEditMode
export default class CustomRichText extends cc.RichText {
    @property({type: cc.Enum(cc.Label.Overflow)})
    overflow: cc.Label.Overflow = cc.Label.Overflow.NONE

    private _overflow: cc.Label.Overflow = cc.Label.Overflow.NONE
    private _maxFragmentWidth: number = 0
    protected _updateRichTextWithMaxWidth(labelString, labelWidth, styleIndex){        
        if(this.overflow == cc.Label.Overflow.SHRINK){
            this._updateRichTextWithMaxWidth_shrink(labelString, labelWidth, styleIndex)
        }else{
            super['_updateRichTextWithMaxWidth'](labelString, labelWidth, styleIndex)
        }
    }

    protected _updateRichText(){    
        this._maxFragmentWidth = 0    
        super['_updateRichText']()
        if(this.overflow == cc.Label.Overflow.SHRINK){
            if(this.maxWidth > 0 && this._maxFragmentWidth > this.maxWidth){
                this.node.scale = this.maxWidth / this._maxFragmentWidth
            }else{
                this.node.scale = 1
            }            
        }else{            
            this.node.scale = 1
        }
    }

    update(){
        if(cc.sys.platform == cc.sys.EDITOR_PAGE){
            this._updateEditor()
        }        
    }

    //用于更新label的显示状态
    private _updateEditor() {
        if(this.overflow != this._overflow){
            this._overflow = this.overflow
            this['_updateRichText']()
        }
    }

    protected _updateRichTextWithMaxWidth_shrink(labelString, labelWidth, styleIndex){
        var fragmentWidth = labelWidth;
        var labelSegment = void 0;
        if (this['_lineOffsetX'] > 0 && fragmentWidth + this['_lineOffsetX'] > this.maxWidth) {        
            var checkStartIndex = 0;
            while (this['_lineOffsetX'] <= this.maxWidth) {
                var checkEndIndex = this['_getFirstWordLen'](labelString, checkStartIndex, labelString.length);
                var checkString = labelString.substr(checkStartIndex, checkEndIndex);
                var checkStringWidth = this['_measureText'](styleIndex, checkString);
                if (!(this['_lineOffsetX'] + checkStringWidth <= this.maxWidth)) {
                if (checkStartIndex > 0) {
                    var remainingString = labelString.substr(0, checkStartIndex);
                    this['_addLabelSegment'](remainingString, styleIndex);
                    labelString = labelString.substr(checkStartIndex, labelString.length);
                    fragmentWidth = this['_measureText'](styleIndex, labelString);
                }
                this['_updateLineInfo']();
                break;
                }
                this['_lineOffsetX'] += checkStringWidth;
                checkStartIndex += checkEndIndex;                
            }
        }
        if (fragmentWidth > this.maxWidth) {
        //   var fragments = textUtils.fragmentText(labelString, fragmentWidth, this.maxWidth, this['_measureText'](styleIndex));
        //   for (var k = 0; k < fragments.length; ++k) {
        //     var splitString = fragments[k];
        //     labelSegment = this['_addLabelSegment'](splitString, styleIndex);
        //     var labelSize = labelSegment.getContentSize();
        //     this['_lineOffsetX'] += labelSize.width;
        //     fragments.length > 1 && k < fragments.length - 1 && this['_updateLineInfo']();
        //   }
            this['_lineOffsetX'] += fragmentWidth;
            this['_addLabelSegment'](labelString, styleIndex);
            this._maxFragmentWidth += fragmentWidth
        } else {
          this['_lineOffsetX'] += fragmentWidth;
          this['_addLabelSegment'](labelString, styleIndex);
        }        
    }
}